import { fetchFactory } from 'isotope-client'

export const checkToken = token => fetchFactory(`/candidats/email/update/checkToken?token=${token}`, {}, '/api')